import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  newPrescriptionData: {},
  allPatients: [],
  allPrescriptions: [],
  currentPatient: {}
  // instructions: {},
  // drugs: []
}

const patientSlice = createSlice({
  name: 'prescriptions',
  initialState,
  reducers: {
    addPatientData: (state, { payload }) => {
      state.newPrescriptionData = payload
      state.allPrescriptions = [...state.allPatients, payload]
    },
    addNewPatient: (state, { payload }) => {
      state.newPrescriptionData = payload
      state.allPatients = [...state.allPatients, payload]
    },
    setCurrentPatient: (state, { payload }) => {
      state.currentPatient = payload
    },
    resetCurrentPatient: (state) => {
      state.currentPatient = {}
    },
    // selectCurrentPatient = state => {
    //   state.currentPatient,
    // }
  }
})

// const selectCurrentPatient = state => state.currentPatient;
export const { addPatientData, addNewPatient, setCurrentPatient, resetCurrentPatient, selectCurrentPatient } = patientSlice.actions
export default patientSlice.reducer